import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import SolutionsGrid from "../sections/SolutionsGrid";
import FinalCta from "../sections/FinalCta";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { CORPORATE_I18N } from "../i18n/services";

export default function CorporateSolutions() {
  const { lang } = useLang();
  const t = CORPORATE_I18N[lang];

  return (
    <>
      <SEO title={t.seoTitle} description={t.seoDesc} />
      <PageHero eyebrow={t.eyebrow} title={t.title} subtitle={t.subtitle}>
        <Link to="/proje-talep" className="btn-primary" data-testid="corporate-hero-cta">
          {t.heroCta} <ArrowRight className="h-4 w-4" />
        </Link>
      </PageHero>

      <SolutionsGrid compact />

      <section className="section bg-[#F8FAFC]">
        <div className="container-x">
          <span className="eyebrow">{t.detailEyebrow}</span>
          <h2 className="mt-3 h2-section max-w-3xl">{t.detailTitle}</h2>

          <div className="mt-12 grid gap-6 lg:grid-cols-2">
            {t.details.map((d, i) => (
              <motion.div
                key={d.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="card-elevate p-7"
                data-testid={`corporate-detail-${i}`}
              >
                <h3 className="h3-card">{d.title}</h3>
                <div className="mt-5 space-y-3">
                  <Row label={t.labelForWho} value={d.forWho} />
                  <Row label={t.labelBenefit} value={d.benefit} />
                  <Row label={t.labelExample} value={d.example} />
                </div>
                <Link to="/proje-talep" className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#2563EB] hover:gap-2.5 transition-all">
                  {t.cardCta} <ArrowRight className="h-4 w-4" />
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <FinalCta />
    </>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex gap-3">
      <CheckCircle2 className="h-4 w-4 mt-0.5 shrink-0 text-[#10B981]" />
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.15em] text-[#2563EB]">{label}</div>
        <div className="mt-0.5 text-sm text-[#334155] leading-relaxed">{value}</div>
      </div>
    </div>
  );
}
